import { httpRequest } from 'http'
import { sendErrorNotification, getReserveSettings } from 'helpers/web_to_client'
import { getReserveCdsList, getLevelSortedReserveSettings } from 'helpers/reserves'

export const SETTINGS_LOAD_REQUEST = 'settings/REQUEST'
export const SETTINGS_LOAD_SUCCESS = 'settings/SUCCESS'
export const SETTINGS_LOAD_ERROR = 'settings/ERROR'

export function startRequest() {
    return {
        type: SETTINGS_LOAD_REQUEST,
        payload: {},
    }
}

export function requestError(errorData) {
    sendErrorNotification(errorData)
    return {
        type: SETTINGS_LOAD_ERROR,
        payload: errorData,
    }
}

export function requestSuccess(data) {
    const {
        craft_machine_url: craftMachineUrl,
        realm,
        pushstream_host: pushStreamHost,
        backend_host: backendHost,
        gateway_host: gatewayHost,
        global_map_url: globalMapUrl,
        clan_quests_url: clanQuestsUrl,
        clan_create_url: clanCreateUrl,
        show_clan_quests_card: showClanQuestsCard,
        signin_token_url: signInTokenUrl,
        stronghold: strongholdSettings,
        icon_url_templates: iconUrlTemplates,
        billboard_messages_url: wgcmpBillboardUrl,
        billboard_new_message_url: wgcmpBillboardNewMessageUrl,
        industrial_resource_multiplier: industrialResourceMultiplier,
        clan_slides: clanSlides,
        clan_entrance_cooldown: clanEntranceCooldown,
        wgshevents_url: wgshEventsUrl,
        wgshevents_api_url: wgshEventsApiUrl,
    } = data

    return {
        type: SETTINGS_LOAD_SUCCESS,
        payload: {
            craftMachineUrl,
            realm,
            pushStreamHost,
            backendHost,
            gatewayHost,
            globalMapUrl,
            clanQuestsUrl,
            clanCreateUrl,
            showClanQuestsCard,
            signInTokenUrl,
            iconUrlTemplates,
            strongholdSettings,
            wgcmpBillboardUrl,
            wgcmpBillboardNewMessageUrl,
            industrialResourceMultiplier,
            clanSlides,
            clanEntranceCooldown,
            wgshEventsUrl,
            wgshEventsApiUrl,
        },
    }
}

export default function requestSettings() {
    return async (dispatch, getState) => {
        const state = getState()
        if (state.settings.loading) {
            return
        }
        dispatch(startRequest())

        try {
            const settings = await httpRequest('/game_api/settings')

            const { reserves } = settings.stronghold

            const clientSetupReserves = Object.keys(reserves).filter(
                (reserveName) => reserves[reserveName].reserve_cds
            )

            for (const reserveType of clientSetupReserves) {
                const cdsCollection = getReserveCdsList(reserves[reserveType].reserve_cds, reserveType)
                try {
                    const clientSettings = await getReserveSettings(cdsCollection.flat(), reserveType)
                    const levelSortedSettings = getLevelSortedReserveSettings(
                        cdsCollection, clientSettings, reserveType
                    )
                    reserves[reserveType].bonus.values.forEach(
                        (bonus, index) => bonus.parameters = levelSortedSettings[index]
                    )
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error('>> WGSH cannot request w2c', error)
                }
            }

            dispatch(requestSuccess(settings))
        } catch (error) {
            dispatch(requestError(error))
        }
    }
}



// WEBPACK FOOTER //
// ./state/actions/settings.js